import apiClient from './AxiosHttp'

const register = (details) => {
    return apiClient.post(`/users/register/`, details)
}

const login = (details) => {
    return apiClient.post(`/auth/token/`, details)
}

const changePassword = (details) => {
    return apiClient.post(`/users/user/password/change/`, details)
}

const getUserDetails = () => {
    return apiClient.get(`/users/user/`)
}

const updateUser = (details) => {
    return apiClient.patch(`/users/user/`, details)
}

const deleteUser = () => {
    return apiClient.delete('/users/user/')
}

const sendOtp = (details) => {
    return apiClient.post(`/users/otp/send/`, details)
}

const resetPassworrd = (details) => {
    return apiClient.post(`/users/otp/set/password/`, details)
}

const googleAuth = (details) => {
    return apiClient.post(`/socials/google/auth/`, details)
}

const authServices = {
    login,
    register,
    getUserDetails,
    changePassword,
    updateUser,
    deleteUser,
    sendOtp,
    resetPassworrd,
    googleAuth,

}

export default authServices

